export default __webpack_public_path__ + "static/media/icon-heart-white.742ca976.svg";